import { useEffect } from "react"
import { Row, Col, FormGroup, Label, Input, Button } from "reactstrap"

const QuotationHeader = ({
  formik,
  getFieldError,
  formatSinceDate,
  quotationNo = "Auto-generated",
  title = "QUOTATION",
  showQuickButtons = true,
  customQuickButtons = null,
  className = "",
  ...props
}) => {
  // Adjust valid_until if it's less than quotation_date
  useEffect(() => {
    const qDate = new Date(formik.values.quotation_date)
    const validUntil = new Date(formik.values.valid_until)

    if (formik.values.valid_until && validUntil < qDate) {
      formik.setFieldValue("valid_until", formik.values.quotation_date)
    }
  }, [formik.values.quotation_date, formik.values.valid_until, formik])

  const setQuickDate = (daysToAdd = 0, field = "valid_until") => {
    const baseDate = new Date(formik.values.quotation_date)
    const newDate = new Date(baseDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0]

    formik.setFieldValue(field, newDate)
  }

  const defaultQuickButtons = [
    { label: "Today", days: 0, field: "valid_until", color: "outline-primary" },
    { label: "+1 Week", days: 7, field: "valid_until", color: "outline-success" },
    { label: "+1 Month", days: 30, field: "valid_until", color: "outline-info" },
    { label: "+2 Month", days: 60, field: "valid_until", color: "outline-info" },
    { label: "+3 Month", days: 90, field: "valid_until", color: "outline-info" },
  ]

  const quickButtons = customQuickButtons || defaultQuickButtons

  return (
    <Row className={`mb-4 ${className}`} {...props}>
      <Col xs={6}>
        <h4 className="text-primary">{title}</h4>
        <Row className="g-3">
          <Col xs={12} sm={6}>
            <FormGroup className="mb-2">
              <Label className="fw-bold small mb-1">Date:</Label>
              <Input
                type="date"
                name="quotation_date"
                value={formik.values.quotation_date}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="form-control-sm"
                {...getFieldError("quotation_date")}
              />
            </FormGroup>
          </Col>
          <Col xs={12} sm={6}>
            <FormGroup className="mb-2">
              <Label className="fw-bold small mb-1">
                Valid Until:{" "}
                <span className="text-muted fw-normal">
                  (
                  {formatSinceDate(
                    formik.values.quotation_date,
                    formik.values.valid_until
                  )}
                  )
                </span>
              </Label>
              <Input
                type="date"
                name="valid_until"
                value={formik.values.valid_until}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="form-control-sm"
                min={formik.values.quotation_date} // prevent choosing earlier date
              />
            </FormGroup>
          </Col>
        </Row>
      </Col>
      <Col xs={6} className="text-end">
        <div className="quotation-no">
          <strong>Quotation No:</strong> {quotationNo}
        </div>

        {showQuickButtons && (
          <div className="mt-2">
            <small className="text-muted me-2">Quick Set:</small>
            {quickButtons.map((button, index) => (
              <Button
                key={index}
                color={button.color}
                size="sm"
                className="me-1 mb-1"
                type="button"
                onClick={() => setQuickDate(button.days, button.field)}
              >
                {button.label}
              </Button>
            ))}
          </div>
        )}
      </Col>
    </Row>
  )
}

export default QuotationHeader
